<template>
    <div class="container-fluid">
        <div v-if="userDetails?.roles?.length > 0">
            <nav class="mobile-bottom-nav">
            <div class="mobile-bottom-nav__item mobile-bottom-nav__item--active">
                <a v-if="userDetails.default_route" :href='userDetails.default_route' class="mobile-bottom-nav__item-content">
                    <i class="fas fa-home fa-2x"></i>
                    Home
                </a>
                <a v-else href="/app" class="mobile-bottom-nav__item-content">
                    <i class="fas fa-home fa-2x"></i>
                    Home
                </a>
            </div>
            <div class="mobile-bottom-nav__item">
                <a href="/orders" class="mobile-bottom-nav__item-content">
                    <i class="fas fa-clipboard-list fa-2x"></i>

                    Orders
                </a>
            </div>
            <div class="mobile-bottom-nav__item">
                <a class="mobile-bottom-nav__item-content" href="/inventory">
                    <i class="fas fa-box fa-2x"></i>
                    <!-- <i class="fas fa-hand-holding-usd fa-2x"></i> -->
                    <span>Inventory</span>
                    <span class="badge"></span>
                </a>


            </div>
            <div class="mobile-bottom-nav__item">
                <a href="/expenses" class="mobile-bottom-nav__item-content">
                    <i class="fas fa-clipboard-list fa-2x"></i>
                    <span>Expenses</span>
                    <span class="badge"></span>
                </a>


            </div>



            <div class="mobile-bottom-nav__item">
                <a @click="toggleSidebar('sidemenu')" class="mobile-bottom-nav__item-content">
                    <i class="fas fa-ellipsis-v fa-2x"></i>
                    More
                </a>

            </div>
        </nav>
        <b-sidebar v-model="isNotificationActive" id="sidebar-notifications" width="80%" right shadow class="bg-light">

        <div class="container">
            <div class="d-inline">
<h3>Notifications</h3>
<a @click="readAll" class="text-primary">Mark all as read</a>
            </div>

        <hr />

            <div v-if="notifications" v-for="notification in notifications.unread" no-body class="mb-1" :key="notification.id">


                <a @click="readNotification(notification.id)" class="text-dark text-left border-0 shadow-o py-2 pl-2" v-b-toggle="'accordion-' + notification.id" block><span class="text-primary" ><i class="bi bi-circle-fill"></i></span>&nbsp;{{ notification.data.title }}</a>
                <hr />
            <b-collapse :id="'accordion-' + notification.id" accordion="my-accordion" role="tabpanel">
                <b-card>
                    <b-card-body>
                    <b-card-text>
                        {{ notification.data.body }}

                    </b-card-text>
                    <b-card-footer>
                        <a v-if="notification.data.url" :href='notification.data.url' class="btn btn-sm btn-outline-secondary">{{ notification.data.action ?? 'Action' }}</a>

                    </b-card-footer>
                    </b-card-body>
                </b-card>

            </b-collapse>
            </div>
        </div>
        </b-sidebar>
        <b-sidebar v-model="isMenuActive" id="sidebar-right" right shadow class="bg-light">

            <div class="px-3 py-2">
                <div>

                    <div v-if="userDetails.roles[0].name ==='Admin' || hasPermission('can switch branches')">
                        <div v-if="companyBranches.length > 1">

                            <div class="dropdown">
                                <h5 class="dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false">
                                    <span class="d-inline-block text-truncate" style="max-width: 220px;"><i
                                            class="bi bi-buildings"></i> &nbsp; {{ companyDetails.name }}</span>
                                </h5>
                                <div class="dropdown-menu">
                                    <a v-if="companyBranch.company" @click="switchCompanyBranch(companyBranch.company.id)"
                                        v-bind="companyBranch.company" class="dropdown-item text-capitalize "
                                        v-for="companyBranch in companyBranches"><span
                                            class="d-inline-block text-truncate"
                                            style="max-width: 220px;">{{ companyBranch.company.name }}</span></a>

                                </div>
                            </div>
                            <div class="d-inline">

                                <a v-if="notifications" @click="toggleSidebar('notif')" href="#" class="notification"> <i class="bi bi-bell"></i> <span v-if="notifications.unread.length > 0" class="badge"><small>{{ notifications.unread.length }}</small></span>

                                </a>

                                <a href="/billing-and-plans">&nbsp;Billing</a>

                            </div>

                        </div>
                        <div v-else>
                            <h5 class="text-capitalize"> <span class="d-inline-block text-truncate"
                                    style="max-width: 220px;"><i class="bi bi-buildings"></i> &nbsp;
                                    {{ companyDetails.name }}</span></h5>
                                    <a class="pl-4" href="/billing-and-plans">&nbsp;Billing</a>
                        </div>
                    </div>
                    <div v-else>
                        <h5 class="text-capitalize"> <span class="d-inline-block text-truncate"
                                style="max-width: 220px;"><i class="bi bi-buildings"></i> &nbsp;
                                {{ companyDetails.name }}</span></h5>

                    </div>
                    <hr />
                </div>

                <ul class="sidemenu-list">
                    <li v-if="userDetails.roles[0].name ==='Admin'"><a href="/analytics/sales"><i class="bi bi-speedometer"></i>Dashboard</a>
                    </li>

                    <li v-if="userDetails.default_route && userDetails.default_route !=='/makesale'"><a href="/makesale"><i class="bi bi-calculator"></i>Make a Sale</a></li>
                    <li v-if="userDetails?.company?.companysettings?.has_kds"><a href="/kds"><i class="bi bi-fork-knife"></i>KDS</a></li>
                    <li v-if="userDetails?.company?.companysettings?.has_reservations"><a href="/reservations"><i class="bi bi-building-check"></i>Reservations</a></li>
                    <!-- <li><a href="/appointments"><i class="bi bi-calendar-check"></i>Appointments</a></li> -->


                    <li><a href="/inventory"><i class="bi bi-box"></i>Inventory</a></li>

                           <li><a href="/wastes"><i class="bi bi-trash"></i>Wastes</a></li>
                    <!--<li><a href="/messages"><i class="bi bi-mailbox"></i>Messages</a></li>-->
                    <!-- <li v-if="userDetails.roles[0].name ==='Admin'"><a href="/marketing"><i class="fas fa-bullhorn"></i>Marketing</a></li>
                            -->
                    <li><a href="/customers"><i class="bi bi-people"></i>Customers</a></li>
                    <li><a href="/bnpl"><i class="bi bi-bag"></i>BNPL (Debtors)</a>
                        <p><small>Buy now pay later</small></p>
                    </li>
                    <li v-if="userDetails.roles[0].name ==='Admin' || hasPermission('can manage users')"><a href="/employees"><i class="bi bi-person-lines-fill"></i>Employees</a>
                    </li>
                    <li v-if="userDetails.roles[0].name ==='Admin' || hasPermission('can manage suppliers')"><a href="/suppliers"><i class="bi bi-box2"></i>Suppliers</a>
                    </li>
                    <li v-if="userDetails.roles[0].name ==='Admin'"><a href="/payroll"><i class="bi bi-box2"></i>Payroll</a>
                    </li>
                    <li v-if="userDetails.roles[0].name ==='Admin' || hasPermission('can change settings')"><a href="/settings/general"><i class="bi bi-gear"></i>Settings</a></li>
                    <li><a href="/payment-transactions"><i class="bi bi-arrow-left-right"></i>Transactions</a></li>
                    <li>
                        <a v-if="userDetails.affiliate" href="/affiliates"><i class="bi bi-cash-coin"></i>Referrals</a>

                        <a v-else @click="addMeToAffiliate" href="#"><i class="bi bi-dice-5"></i>Refer & <span class="text-primary"> Earn over Kshs.50k</span></a></li>
                    <li><a href="/profile"><i class="bi bi-person-circle"></i>Profile</a></li>
                    <li>
                        <a class="text-primary" target="_blank" href="https://wa.me/254725445898">
                            <i class="bi bi-whatsapp"></i> Support/Feedback

                        <p><small>whatsapp us directly.</small></p>
                        </a>
                    </li>
                   <li>
                    <a href="/logout"
                        onclick="event.preventDefault(); localStorage.clear(); document.getElementById('logout-form').submit();">
                        <i class="bi bi-box-arrow-right"></i>Sign Out
                    </a>
                    <form id="logout-form" action="/logout" method="POST" style="display: none;">
                        <input type="hidden" name="_token" :value="csrf">
                    </form>
                </li>

                </ul>
                <ul class="sidemenu-list" v-if="userDetails.isDukakit===1 && userDetails.roles[0].name ==='Admin'">
                    <li><a href="/s-dashboard"><i class="bi bi-gear"></i>Super DashB</a></li>

                </ul>

            </div>


        </b-sidebar>

        </div>
      <b-modal no-close-on-esc no-close-on-backdrop ref="roleNotSetModal" hide-footer hide-header>
        <div class="text-center py-5">
            <h2 class="text-danger">Role error!</h2>
            <hr />
            <p >No role has been set for this account</p>

            <p>Please talk to your admin</p>
        </div>
      </b-modal>

    </div>
</template>

<script>
    import { BSidebar,BButton } from 'bootstrap-vue'
    import { mapGetters } from 'vuex';
import productCacheService from '../IndexDB/productCacheService';
    export default {
        name: "BottomMenu",
        // props:['role','notifications','companytype'],
        components: {
            'b-button':BButton,
            'b-sidebar':BSidebar
        },
        computed: {
            csrf() {
                return document.querySelector('meta[name="csrf-token"]').getAttribute('content');
            },
            ...mapGetters(['userDetails']),

        },
        data() {
            return {
                companyBranches:[],
                companyDetails:{},
                notifications:{
                    all:{},
                    unread:{}
                },
                isNotificationActive:false,
                isMenuActive:false,
            }
        },

        mounted(){

                this.getUserCompanyDetails();
                this.getNotifications();

        },


        methods:{

            logout(){
                axios.post("logout").then(response => {

                })
                    .catch(error => {

                    });

            },
            addMeToAffiliate()
            {
                axios.post('/api/join-affiliates').then(response=>
                {
                    if(response.status === 200)
                    {
                        window.location.href='/affiliates?new=true'

                    }
                }).catch()
            },
            readNotification(notificationId)
            {
                axios.put('/api/notifications',{id:notificationId}).then(response=>
                {
                    if(response.status === 200)
                    {
                       console.log(response)

                    }
                }).catch()
            },
            readAll()
            {
                axios.put('/api/notifications',{all:true}).then(response=>
                {
                    if(response.status === 200)
                    {
                       console.log(response)

                    }
                }).catch()
            },
            switchCompanyBranch(companyId)
            {
                axios.get('/api/switch-branch',{params:{companyId:companyId}}).then(results=>{
                    if(results.status === 200)
                    {
                        productCacheService.hotReloadLocalDB()
                      this.$store.commit('resetStore')
                      this.$store.commit('removeUserDetails')

                        window.location.reload()

                    }
                }).catch()
            },
            getUserCompanyDetails() {
                axios.get('/api/user')
                    .then(result => {
                        this.$store.commit('addUserDetails', result.data);
                        this.companyDetails = result.data.company



                        if(this.userDetails?.roles?.length < 1)
                        {
                            // console.log(this.userDetails.roles);
                            this.$refs.roleNotSetModal.show()
                        }
                        this.companyBranches = result.data.companybranches

                    }).catch(errors => {
                        console.log(errors.message)
                    });
            },
            hasPermission(permissionName) {
                 return this.userDetails.permissions.some(permission => permission.name === permissionName);
            },
            async getNotifications(permissionName) {
                axios.get('/api/notifications')
                    .then(results => {
                        if(results.status === 200)
                        {
                            this.notifications.all = results.data.all
                            this.notifications.unread = results.data.unread
                        }
                    })
            },

            toggleSidebar(side) {
            if (side === 'notif') {
                this.isNotificationActive = !this.isNotificationActive;
                if (this.isNotificationActive) {
                this.isMenuActive = false;
                }
            } else if (side === 'sidemenu') {
                this.isMenuActive = !this.isMenuActive;
                if (this.isNotificationActive) {
                this.isMenuActive = false;
                }
            }
            },

        }

    }
</script>

<style scoped>
    .sidemenu-list li a{
        font-size: 14px;
        font-weight: 500;
        color:#1c252c;
        font-family: "Roboto", sans-serif;
        font-size: 14px;
        line-height: 24px;

    }

    .sidemenu-list li a i{
        padding-right: 10px;

    }
    .notification {


        text-decoration: none;

        position: relative;

        margin-top: 30px;
        margin-bottom: 20px;
        margin-right: 15px;
    }


    .notification .badge {
        position: absolute;
        top: -7px;
        right: -9px;
        border-radius: 50%;
        background-color: #fd4719;
        color: white;
    }

</style>
